// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
import IconBack from 'components/svg/arrows/arrow-left.svg'
import { loop } from 'utilities/objects'

class Honours extends React.Component {
	constructor() {
		super()

		this.state = {
			showContent: false
		}
	}

	componentDidMount() {
		this._isMounted = true

		this.update()
	}

	componentWillUnmount() {
		this._isMounted = false
	}

	componentDidUpdate( prevProps, prevState ) {
		this.update()
	}

	update = () => {
		const { history } = this.props
		const { showContent } = this.state

		if ( 'POP' == history.action && ! showContent ) {
			setTimeout( () => {
				this.setState( {
					showContent: true
				} )
			}, 400 )
		}
	}

	render() {
		const { postsData, match, location, history } = this.props
		const { showContent } = this.state

		if ( ! postsData ) {
			return null
		}

		if ( 'POP' == history.action && ! showContent ) {
			return null
		}

		let postsMarkup = []

		loop( postsData.categories, ( key, item ) => {
			if ( '/honours/category/master-honours/' == item.url ) {
				return null
			}

			// let hasImage = ( item.featured_image && item.featured_image.url )
			let hasImage = false
			let className = hasImage ? '-item with-image' : '-item'

			postsMarkup.push(
				<Link to={ item.url } className={ className } key={ key }>
					<div className="-inner">
						<div className="-bg" style={ { background: item.color } } />
						<div className="-arrow" />

						{ hasImage &&
							<div className="-image">
								<img src={ item.featured_image.url } alt="" />
							</div>
						}

						<div className="-text">
							<h3 dangerouslySetInnerHTML={ { __html: item.title } }></h3>
						</div>
					</div>
				</Link>
			)
		} )

		const posts = postsMarkup.length ? (
			<div className="-posts">
				<div className="-inner">
					<div className="-items">
						{ postsMarkup }
					</div>
				</div>
			</div>
		) : ''

		return (
			<div className="page-sections-wrap">
				<div className="page-sections">
					<section className="page-section page-section-honours is-honours-cats is-odd">
						<div className="js-scroll-position"></div>

						{ posts }
					</section>

					{/* !! posts &&
						<section className="page-section page-section-back-to">
							<Link to="/honour-types" className="button -svg-stroke"><IconBack /><span>Back</span></Link>
						</section>
					*/}
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		postsData: state.page.selected
	}
}

export default connect( mapStateToProps )( Honours )



// WEBPACK FOOTER //
// ./components/Honours/Honours.jsx